import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { FinalCTA } from './components/FinalCTA';
import { HomePage } from './pages/HomePage';
import { HumanCapabilityPage } from './pages/HumanCapabilityPage';
import { SemanticKnowledgePage } from './pages/SemanticKnowledgePage';
import { CJIPage } from './pages/CJIPage';
import { NCJIPage } from './pages/NCJIPage';
import { SolutionsPage } from './pages/SolutionsPage';
import { AboutPage } from './components/AboutPage';
import { ResearchPage } from './pages/ResearchPage';
import { RoadmapPage } from './pages/RoadmapPage';
import { InvestPage } from './pages/InvestPage';
import { LlmVsSkpPage } from './pages/LlmVsSkpPage';
import { PartnershipsPage } from './pages/PartnershipsPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
import { GovernmentPage } from './pages/applications/GovernmentPage';
import { EducationPage } from './pages/applications/EducationPage';
import { EmployersPage } from './pages/applications/EmployersPage';
import { CivilSocietyPage } from './pages/applications/CivilSocietyPage';
import { LeadershipPage } from './pages/applications/LeadershipPage';
import { ReasoningQualityPage } from './components/ReasoningQualityPage';
import { ConsequentialThinkingPage } from './components/ConsequentialThinkingPage';
import { ManipulationResistancePage } from './components/ManipulationResistancePage';
import { EmotionalRegulationPage } from './components/EmotionalRegulationPage';
import { SocialCooperationPage } from './components/SocialCooperationPage';
import { SelfDirectionPage } from './components/SelfDirectionPage';
import { LeadershipResponsibilityPage } from './components/LeadershipResponsibilityPage';
import { IndividualLevelPage } from './components/IndividualLevelPage';
import { OrganizationalLevelPage } from './components/OrganizationalLevelPage';
import { MunicipalScalePage } from './components/MunicipalScalePage';
import { NationalScalePage } from './components/NationalScalePage';
type RouteConfig = {
  page: React.ComponentType;
  withCTA: boolean;
};
const routes: Record<string, RouteConfig> = {
  '/': {
    page: HomePage,
    withCTA: false
  },
  '/human-capability': {
    page: HumanCapabilityPage,
    withCTA: false
  },
  '/semantic-knowledge': {
    page: SemanticKnowledgePage,
    withCTA: false
  },
  '/llm-vs-skp': {
    page: LlmVsSkpPage,
    withCTA: false
  },
  '/cji': {
    page: CJIPage,
    withCTA: true
  },
  '/ncji': {
    page: NCJIPage,
    withCTA: true
  },
  '/solutions': {
    page: SolutionsPage,
    withCTA: false
  },
  '/about': {
    page: AboutPage,
    withCTA: false
  },
  '/research': {
    page: ResearchPage,
    withCTA: false
  },
  '/roadmap': {
    page: RoadmapPage,
    withCTA: false
  },
  '/partnerships': {
    page: PartnershipsPage,
    withCTA: false
  },
  '/investors': {
    page: InvestPage,
    withCTA: false
  },
  '/contact': {
    page: ContactPage,
    withCTA: false
  },
  '/privacy': {
    page: PrivacyPolicyPage,
    withCTA: false
  },
  '/terms': {
    page: TermsOfServicePage,
    withCTA: false
  },
  '/government': {
    page: GovernmentPage,
    withCTA: true
  },
  '/education': {
    page: EducationPage,
    withCTA: true
  },
  '/employers': {
    page: EmployersPage,
    withCTA: true
  },
  '/civil-society': {
    page: CivilSocietyPage,
    withCTA: true
  },
  '/leadership': {
    page: LeadershipPage,
    withCTA: true
  },
  '/reasoning-quality': {
    page: ReasoningQualityPage,
    withCTA: true
  },
  '/consequential-thinking': {
    page: ConsequentialThinkingPage,
    withCTA: true
  },
  '/manipulation-resistance': {
    page: ManipulationResistancePage,
    withCTA: true
  },
  '/emotional-regulation': {
    page: EmotionalRegulationPage,
    withCTA: true
  },
  '/social-cooperation': {
    page: SocialCooperationPage,
    withCTA: true
  },
  '/self-direction': {
    page: SelfDirectionPage,
    withCTA: true
  },
  '/leadership-responsibility': {
    page: LeadershipResponsibilityPage,
    withCTA: true
  },
  '/individual-level': {
    page: IndividualLevelPage,
    withCTA: true
  },
  '/organizational-level': {
    page: OrganizationalLevelPage,
    withCTA: true
  },
  '/municipal-scale': {
    page: MunicipalScalePage,
    withCTA: true
  },
  '/national-scale': {
    page: NationalScalePage,
    withCTA: true
  }
};
export function App() {
  const [path, setPath] = useState(getInitialPath);
  useEffect(() => {
    const handlePopState = () => {
      setPath(normalizePath(window.location.pathname));
      window.scrollTo(0, 0);
    };
    const handleClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const anchor = (event.target as HTMLElement).closest('a');
      if (!anchor || anchor.target === '_blank') return;
      const href = anchor.getAttribute('href');
      if (!href || !href.startsWith('/') || href.startsWith('//')) return;
      event.preventDefault();
      const nextPath = normalizePath(href);
      if (nextPath !== window.location.pathname) {
        window.history.pushState({}, '', nextPath);
      }
      setPath(nextPath);
      window.scrollTo(0, 0);
    };
    window.addEventListener('popstate', handlePopState);
    document.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('popstate', handlePopState);
      document.removeEventListener('click', handleClick);
    };
  }, []);
  const route = routes[path] ?? routes['/'];
  const Page = route.page;
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-0" data-mp="2jsg6dgvw5zv3">
      <Navigation data-id="element-1" data-mp="2nti7625gijz6" />
      <main data-id="element-2" data-mp="2supey17lnj5u">
        <Page data-id="element-3" data-mp="2sufn082zv1xi" />
        {route.withCTA && <FinalCTA data-id="element-4" data-mp="2stecc4pw4hgb" />}
      </main>
      <Footer data-id="element-5" data-mp="2sslbtlhiyo6m" />
    </div>;
}

// Renamed pages keep working at their old addresses.
const renamedPaths: Record<string, string> = {
  '/research-areas': '/roadmap',
  '/invest': '/investors'
};
function normalizePath(pathname: string) {
  const clean = pathname.replace(/\/+$/, '');
  const path = clean === '' ? '/' : clean;
  return renamedPaths[path] ?? path;
}

// Old links used "#page" addresses (e.g. /#cji). Redirect them to clean paths.
function getInitialPath() {
  const legacy = window.location.hash.slice(1);
  if (legacy) {
    const legacyPath = legacy === 'home' ? '/' : `/${legacy}`;
    if (routes[legacyPath]) {
      window.history.replaceState({}, '', legacyPath);
      return legacyPath;
    }
  }
  return normalizePath(window.location.pathname);
}